import React from "react";
import * as cls from "./writtenWorks.module.scss";
import { useSelector } from "react-redux";
import { TableLoader, TableModel } from "../../components/tableLoader";
function WrittenWorks() {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const loader = {
    title: "Письменные работы",
    icon: "survey",
    request: {
      method: "post",
      path: "/student/portfolio/written_works",
      data: {
        access_token,
        study_contract_id: contractId,
      },
    },
    parser: createModel,
  };
  function createModel(response) {
    const table = new TableModel(response);
    table.columns.forEach((element) => {
      if (element.field === "reports" || element.field === "theme") {
        element.type = "html";
      }
      if (element.field === "receiption_date") {
        element.type = "date";
      }
    });

    return table;
  }
  return <TableLoader {...loader} />;
}

export default WrittenWorks;
